export const RESULTS_PER_PAGE_KEY = 'as-results-per-page';

export function getResultsPerPageFromLocalStorage(): number | undefined {
  try {
    const value = localStorage?.getItem(RESULTS_PER_PAGE_KEY);
    return value ? parseInt(value, 10) : undefined;
  } catch {
    return undefined;
  }
}

export function setResultsPerPageToLocalStorage(numberOfResults: number): void {
  try {
    localStorage?.setItem(RESULTS_PER_PAGE_KEY, numberOfResults.toString());
  } catch {
    // localStorage may be unavailable
  }
}
